module.exports = __webpack_public_path__ + "img/图片7.7a3bfd06.png";